(function() {
    var $modal = $('#messageImportantModal');
    if ($modal.length === 0) return;

    var storageKey = 'message_important_closed';
    var isClosed = JSON.parse(window.sessionStorage.getItem(storageKey));
    var lang = document.documentElement.lang;
    var currentSection = document.body.getAttribute('data-alert-section') || document.body.hasAttribute('data-alert-section');

    if (isClosed || !currentSection) return;

    var $title = $modal.find('[data-mi-title]');
    var $body = $modal.find('[data-mi-body]');

    $.ajax({
        url: '/' + lang + "/api/alert-members/",
        method: "GET"
    }).done(function(data) {
        if (data.ok) {
            var alerts = data.data.filter(function(item) {
                return item.alert.section ? item.alert.section === currentSection : item;
            });
            if (alerts.length === 0) return;

            var id = alerts[0].id;
            var alert = alerts[0].alert;
            $modal.attr('data-mi-id', id);
            $title.text(alert.title);
            $body.html(alert.message);
            $modal.modal('show');
        }
    });

    $modal.on('hide.bs.modal', function() {
        var id = $modal.attr('data-mi-id');
        if (!id) return;

        $.ajax({
            url: '/' + lang + '/api/alert-members/' + id + '/close',
            method: "POST"
        }).done(function(data) {
            if (data.ok) {
                window.sessionStorage.setItem(storageKey, true);
            }
        });
    });
})();
